/**
 * Generate a random hex string of the given length.
 * Used to salt repeated subscription inputs so Apollo restarts the subscription.
 */
export function randomHex (length: number): string {
  return Math.random().toString(16).slice(2, 2 + length)
}
